import { useState, useEffect } from 'react';
import { FieldRow } from '../../shared';
import styles from './JudgingSection.module.css';

export interface JudgingData {
  number_of_categories: number | null;
  judging_criteria: string | null;
  celebration_type: string | null;
  qc_flag_judging: boolean | null;
  qc_flag_judging_notes: string | null;
}

export interface JudgingSectionProps {
  data: JudgingData;
  editable: boolean;
  onChange?: (updates: Partial<JudgingData>) => void;
}

export function JudgingSection({ data, editable, onChange }: JudgingSectionProps) {
  const [localData, setLocalData] = useState<JudgingData>(data);

  useEffect(() => {
    setLocalData(data);
  }, [data]);

  const handleFieldChange = (field: keyof JudgingData, value: string | number) => {
    const updates = { ...localData, [field]: value };
    setLocalData(updates);
    onChange?.(updates);
  };

  return (
    <div className={styles.container}>
      <div className={styles.fieldsContainer}>
        <FieldRow
          label="Number of Categories"
          value={localData.number_of_categories !== null ? String(localData.number_of_categories) : ''}
          editable={editable}
          onChange={(v) => {
            const numValue = v.trim() === '' ? null : parseInt(v, 10);
            handleFieldChange('number_of_categories', numValue ?? 0);
          }}
        />
        <FieldRow
          label="Judging Criteria"
          value={localData.judging_criteria}
          editable={editable}
          onChange={(v) => handleFieldChange('judging_criteria', v)}
          multiline
        />
        <FieldRow
          label="Celebration Type"
          value={localData.celebration_type}
          editable={editable}
          onChange={(v) => handleFieldChange('celebration_type', v)}
        />
      </div>
    </div>
  );
}

export default JudgingSection;
